/**
 * Client metadata constants
 * @module
 */

/**
 * version of the client package, should follow semantic versioning
 * @type String
 */
exports.VERSION = __CLIENT_VERSION__;

/**
 * client name for reporting purposes
 * @type String
 */
exports.NAME = 'js';
